
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconCardinalEast as ObiSimplifiedBeaconCardinalEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-cardinal-east.js';
 
 
 

 
 export const ObiSimplifiedBeaconCardinalEast = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-cardinal-east',
   elementClass: ObiSimplifiedBeaconCardinalEastElement,
   events: {
     
   }
  });
 
 